import { useEffect, useState } from "react";
import { db } from "../firebase";
import { PlanService } from "../services/PlanService";
import {
  CONSTELLATION_PLATFORM_PRICE,
  CONSTELLATION_SOCIAL_PRICE,
  constellationPricesFromPlans,
} from "../constants/planCommerce";

const FALLBACK = {
  social: CONSTELLATION_SOCIAL_PRICE,
  platform: CONSTELLATION_PLATFORM_PRICE,
};

/** Lê o valor atual dos planos de constelação (social e plataforma). */
export function useConstellationPlanPrices(): { social: number; platform: number } {
  const [prices, setPrices] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    PlanService.fetchActivePlans(db)
      .then((plans) => {
        if (!cancelled) setPrices(constellationPricesFromPlans(plans));
      })
      .catch(() => {
        if (!cancelled) setPrices(FALLBACK);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return prices;
}
